import React, { useState, useEffect } from 'react';
import { Alert, Modal, Form, Button, ButtonGroup, Row, Col, Card, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getDiagnosis } from '../../redux/diagnosis/actions'
import { withRouter } from 'react-router-dom';
import { getHealth, saveHealth, editHealth, deleteHealth } from '../../redux/health/actions';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarConfig from '../../components/SidebarConfig';
import messages from '../../redux/messages';
import CustomTable from '../../components/CustomTable';
import UserMenuComponent from '../../components/profile/UserMenuComponent';

const HealthManteinance = props => {

  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState('');

  const columns = [
    {
      Header: 'Diagnóstico',
      accessor: 'diagnostico_list[0].descripcion'
    },
    // {
    //   Header: 'Empleado',
    //   accessor: 'empleado'
    // },
    {
      Header: 'Fecha',
      accessor: 'fecha'
    },
    {
      id: 'customButtons',
      Filter: '',
      Cell: value => (<div
        className="btn-group"
        role="group">
        <Button
          size="sm"
          variant="link"
          type="button"
          onClick={() => onEdit(value.row.original, value.row.index)}>
          <i className="material-icons">edit</i>
        </Button>
        <Button
          size="sm"
          className="text-danger"
          variant="link"
          type="button"
          onClick={() => onDelete(value.row.original.id, value.row.index)}>
          <i className="material-icons">close</i>
        </Button>
      </div>)
    }
  ];

  //Redux
  const dispatch = useDispatch();
  //EmerContact
  const loading = useSelector(store => store.health.loading);
  const data = useSelector(store => store.health.health);
  //const dataLenght = useSelector(store => store.health.healthLength);
  const saveHealthLoader = useSelector(store => store.health.saveLoader);

  //diagnosis
  const diagnosis = useSelector(store => store.diagnosis.diagnosis);
  const diagnosisLoader = useSelector(store => store.diagnosis.loading);
    

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    setValidated(false);
  }

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    setValidated(false);
  }

  useEffect(() => {
    dispatch(getHealth({
      filter: props.match.params.id,
      empleado: props.match.params.id}, parseInt(props.match.params.type)));
  }, [dispatch, filter, props.match.params.id, props.match.params.type]);
  
  useEffect(() => {
    dispatch(getDiagnosis({}, parseInt(props.match.params.type)));
  }, [dispatch])

  const onSubmit = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const oData = {
      diagnostico: e.target.diagnostico.value,
			fecha: [new Date(e.target.fecha.value).toLocaleDateString()],
			empleado: parseInt(props.match.params.id),
      enfermedad: e.target.enfer.value
    }

    if(edit){
      dispatch(editHealth(oData, editItem.id, index, parseInt(props.match.params.type)));
      setShowModal(false);
    }else{
      dispatch(saveHealth(oData, parseInt(props.match.params.type)));
      e.target.reset();
      setShowModal(false);
    }

  }

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteHealth(id, index, parseInt(props.match.params.type)));
    }
  }

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1">
            <h2 className="font-weight-bold d-flex justify-content-between align-items-center text-uppercase">{ props.match.params.name }
              <ButtonGroup>
                <Button
                  onClick={props.history.goBack} 
                  size="sm"><i className="material-icons">keyboard_return</i></Button>
              <UserMenuComponent id={props.match.params.id} name={props.match.params.name} type={props.match.params.type} /> 
              <Button
                variant="primary"
                size="sm"
                onClick={() => onAdd()}><i className="material-icons">add</i></Button>
              </ButtonGroup>
            </h2>
            <hr />
            <h6>Salud </h6>
          </div>
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center" />
              </div>
            ) : data.length > 0 ? (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={data} />
                  </Card.Body>
                </Card>
              </>
            ) : (
              <Alert variant="info" className="my-4">
                No tiene datos relacionados a su salud, comience agregandolos.
              </Alert>
            )
          }
        </div>
      </div>
      <Modal
        show={showModal}
        size="lg"
        onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>{edit ? 'Editar ficha salud' : 'Crear ficha salud'}</Modal.Title>
          </Modal.Header>
          <Modal.Body >
          <Form.Group controlId="diagnostico">
              <Row>
                <Col sm={ diagnosisLoader ? '10': '12' }>
                  <Form.Label className="ml-2">Diagnóstico</Form.Label>
                  <Form.Control
                    as="select"
                    id="diagnostico"
                    name="diagnostico"
                    className="rounded-pill"
                    required
                    defaultValue={ edit ? editItem.diagnostico_list[0].codigo : null}
                    placeholder="Diagnóstico">
                      {
                        diagnosis.map(item => (
                          <option key={item.codigo} value={item.codigo}>{item.descripcion}</option>
                        ))
                      }
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    **Campo requerido
                  </Form.Control.Feedback>
                </Col>
                {
                  diagnosisLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )
                }
              </Row>
            </Form.Group>
            <Form.Group controlId="enfer">
              <Form.Label className="ml-2">Descripción de la enfermedad</Form.Label>
              <Form.Control
                name="enfer"
                className="rounded-pill"
                required
                type="text"
                pattern="[a-zA-Z0-9][a-zA-Z0-9\s]*"
                defaultValue={edit ? editItem.enfermedad : null}
                placeholder="Enfermedad"></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="fecha">
              <Form.Label className="ml-2">Fecha</Form.Label>
              <Form.Control
                name="fecha"
                className="rounded-pill"
                required
                type="date"
                defaultValue={edit ? editItem.fecha  : null}
                placeholder="Fecha"></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
            <Button
              className="rounded-pill" 
              disabled={saveHealthLoader}  
              variant="primary" 
              type="submit">
                {
                  saveHealthLoader ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  ): null
                }
                Guardar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default withRouter(HealthManteinance)
